// section: main-blog
theme.Blog = (function() {
  function Blog(container) {
    this.container = container;
    this.section = theme.utils.getParents(this.container, 'blog-section');
    this.blog = this.section.querySelector('.blog-content');
    this.init();
  }

  Blog.prototype = Object.assign({}, Blog.prototype, {
    init: function(){
      var self = this;
      this.container.querySelectorAll('.tag-button').forEach( (tag) => {
        tag.addEventListener("click", function(e) {
          e.preventDefault();

          self.container.querySelectorAll('.tag-button').forEach( (button) => {
            button.classList.remove('tag-button-selected');
          });

          this.classList.add('tag-button-selected');
          var url = this.querySelector('a').href;
          self.getContent(url);
        })
      });
    },

    getContent(url) {
      var self = this, response, content, loader = Shopify.theme_settings.loader;
      self.blog.innerHTML = loader;
      window.ajaxURL(url).then(function (data) {
        response = new DOMParser().parseFromString(data, 'text/html');
        content = response.querySelector(".blog-content").innerHTML;
        self.blog.innerHTML = content;
      });
    }
  })

  return Blog;
})();